import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import { Typography } from "./typography";

interface EmptyProps {
  title?: string;
  description?: string | ReactNode;
  button?: ReactNode;
  className?: string;
}

export function Empty({ title, description, button, className }: EmptyProps) {
  return (
    <div
      className={cn(
        "flex flex-col flex-1 items-center justify-center rounded-md bg-gray-100 py-34",
        className
      )}
    >
      {title && (
        <Typography variant="subheading2" tone="description" className="mb-4">
          {title}
        </Typography>
      )}
      {description && typeof description === "string" ? (
        <Typography variant={"body2"} tone="description">
          {description}
        </Typography>
      ) : description}
      {button}
    </div>
  );
}
